export enum UserRoles {
  superAdmin = 'super-admin',
  owner = 'owner',
  admin = 'admin',
  mechanic = 'mechanic',
  user = 'user',
}

export enum ScreenArtboardScrollDirection {
  vertical = "vertical",
  horizontal = "horizontal",
  noscroll = "noscroll"
}
